import * as Tabs from '@radix-ui/react-tabs'
import { parseAsStringLiteral, useQueryState } from 'nuqs'
import { DETECTION_SOURCE_PARAM, DETECTION_SOURCES } from '../../routes.ts'
import * as scansOverviewPageStyles from '../scans-overview-page.css'
import { AiDetectionTab } from './ai-detection-tab.tsx'
import { OpenGrepRulesTab } from './opengrep-rules-tab.tsx'

// Which detection source is open lives in the URL (via nuqs, the app's URL-state tool) so the
// selection survives a page refresh and is deep-linkable, matching how the primary repository tab
// persists via `?tab=`. The vocabulary lives in `routes.ts` so links elsewhere can point at one.

export type DetectionsTabProps = {
  onSwitchToThreatModel: () => unknown
}

/**
 * The repository "Detections" tab hosts two detection sources: Pixee's context-graph-generated
 * opengrep rules ("Generated rules") and the Pixee AI Scanner ("AI detection", ENH-590).
 */
export const DetectionsTab: React.FC<DetectionsTabProps> = ({ onSwitchToThreatModel }) => {
  const [subTab, setSubTab] = useQueryState(
    DETECTION_SOURCE_PARAM,
    parseAsStringLiteral(DETECTION_SOURCES).withDefault('generated-rules').withOptions({ history: 'replace' })
  )

  return (
    <Tabs.Root
      value={subTab}
      onValueChange={value => {
        if (value === 'generated-rules' || value === 'ai-detection') {
          void setSubTab(value)
        }
      }}
    >
      <Tabs.List aria-label="Detection sources" style={{ marginBottom: '24px' }}>
        <Tabs.Trigger value="generated-rules" className={scansOverviewPageStyles.tab}>
          Generated rules
        </Tabs.Trigger>
        <Tabs.Trigger value="ai-detection" className={scansOverviewPageStyles.tab}>
          AI detection
        </Tabs.Trigger>
      </Tabs.List>
      <Tabs.Content value="generated-rules" tabIndex={-1}>
        <OpenGrepRulesTab onSwitchToThreatModel={onSwitchToThreatModel} />
      </Tabs.Content>
      <Tabs.Content value="ai-detection" tabIndex={-1}>
        <AiDetectionTab />
      </Tabs.Content>
    </Tabs.Root>
  )
}
